module.exports = __webpack_public_path__ + "static/loopdesign2-45faaab3f32f88046853a768207c305d.png";